import React, { useState } from "react";
import { Card, Form, Input, Button } from "antd";
import { useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";
import { Severty, ShowToast } from "../helper/toast";

const PASSWORD_POLICY_REGEX = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&^()_\-+=[\]{}|:;,.~`]{8,}$/;

const ChangePassword = () => {
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = (values) => {
    setLoading(true);
    request({
      url: apiPath.authChangePassword,
      method: "POST",
      data: {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      },
      onSuccess: (data) => {
        ShowToast(data?.message || "Password updated", Severty.SUCCESS);
        form.resetFields();
        setLoading(false);
        navigate("/dashboard");
      },
      onError: (err) => {
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "Could not change password";
        ShowToast(msg, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingTop: 30,
      }}
    >
      <Card
        title="Change password"
        bordered={false}
        className="criclebox"
        style={{ width: "100%", maxWidth: 520 }}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="currentPassword"
            label="Current password"
            rules={[{ required: true, message: "Enter your current password" }]}
          >
            <Input.Password
              placeholder="Enter current password"
              autoComplete="current-password"
            />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New password"
            dependencies={["currentPassword"]}
            rules={[
              { required: true, message: "Enter a new password" },
              { min: 8, message: "Password must be at least 8 characters" },
              {
                pattern: PASSWORD_POLICY_REGEX,
                message:
                  "Password must be alphanumeric and include at least 1 letter and 1 number",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const currentPassword = getFieldValue("currentPassword");
                  if (!value || !currentPassword || value !== currentPassword) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("New password must be different from current password")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Enter new password"
              autoComplete="new-password"
            />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm new password"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Enter confirm new password"
              autoComplete="new-password"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Update password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePassword;
